import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DataCleansingService } from '../../services/data-cleansing.service';
import { FilterModel } from '../../models/filter/filter-request.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FilterResponseModel } from '../../models/filter/filter-response.model';
import { GlobalService } from '../../services/global.service';
import { FilterFieldTypes } from '../../shared/common-constants';
import { CleansingRuleComponent } from '../cleansing-rule/cleansing-rule.component';
import { Globals } from '../../models/globals.model';
import { ConfirmModelComponent } from '../../common/confirm-model/confirm-model.component';
import { AlertComponent } from '../../common/alert/alert.component';
import { Title } from '@angular/platform-browser';
import { RulesModel } from '../../models/rules/rules.model';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { TenantService } from 'src/app/services/tenant.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.css']
})
export class RulesComponent implements OnDestroy {
  isLoader: boolean = false;
  emptyData = false;
  displayedColumns: string[] = ['dataSourceName', 'tagName', 'cleansingRules', 'updatedBy', 'action'];
  rulesDataSource: MatTableDataSource<RulesModel>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: RulesModel[];
  selectedCleansingRuleConfigId: RulesModel;
  @ViewChild('popOver') public popover: NgbPopover;
  public destroyed = new Subject<any>();
  searchText: string;

  constructor(private readonly dataCleansingService: DataCleansingService, public globals: Globals, public globalService: GlobalService,
    private readonly titleService: Title, private readonly router: Router, private readonly tenantService: TenantService, public dialog: MatDialog) {
    const emptyList: any[] = [];
    this.rulesDataSource = new MatTableDataSource(emptyList);
    titleService.setTitle('Data Cleansing');
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      takeUntil(this.destroyed),
      switchMap((data: any) => { this.getToken(); return of(data); }),
      switchMap((data) => { this.getRulesData(this); return of(data); }),
    ).subscribe((error) => {
      console.log(error);
    });
  }
  getToken() {
    this.dataCleansingService.getToken().subscribe(locData => {
      return of(this);
    }, (error) => {
      console.log(error);
    });
  }

 

  /**
   * Fetches the rules data
   * @param thisRef
   */
  getRulesData(thisRef: RulesComponent) {
    if(thisRef.tenantService.getCurrentTenant()){
    thisRef.emptyData = false;
    thisRef.isLoader = true;
    thisRef.selectedFilters = [];
    thisRef.dataCleansingService.getAllRules().subscribe((response: RulesModel[]): void => {
      if (response && response.length > 0) {
        thisRef.masterData = [...response];
        thisRef.rulesDataSource = new MatTableDataSource(response);
        if (response.length > 0) {
          thisRef.rulesDataSource.sort = thisRef.sort;
          thisRef.rulesDataSource.paginator = thisRef.paginator;
          if (thisRef.globalService.isNotNull(thisRef.searchText)) {
            thisRef.globalService.applyFilter(thisRef.searchText, thisRef.rulesDataSource);
          }
        }
        thisRef.isLoader = false;
      }
      else {
        thisRef.rulesDataSource.data = [];
        thisRef.isLoader = false;
        this.emptyData = true;
      }      
      thisRef.filterList = [];
      thisRef.createFilterList();
    });
  }
  }

  setSearchText(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.searchText = filterValue;
  }

  /**Add cleansing rule */
  addCleansingRule() {
    let dataToPass = { displayType: "add" };
    this.openModelWindow(this.getRulesData, this, CleansingRuleComponent, '80%', 'custom-modalbox', dataToPass);
  }

  /**Creates data for filter list */
  createFilterList() {
    let cols: string[] = ['dataSourceName', 'tagName', 'cleansingRules', 'updatedBy'];
    this.rulesDataSource.filterPredicate = (data, filter: string): boolean =>{
      return data.dataSourceName.toLowerCase().includes(filter)||data.cleansingRules.length.toString().includes(filter)||data.tagName.toLowerCase().includes(filter)||data.updatedBy.toLowerCase().includes(filter) 
    };
    for (let a = 0; a < cols.length; a++) {
      let tempFilter: FilterModel = new FilterModel();
      tempFilter.fieldName = this.globalService.replaceDisplayText(cols[a]);
      tempFilter.fieldType = FilterFieldTypes.text;
      let unique;
      if (cols[a] == "dataSourceName") {
        unique = [...new Set(this.rulesDataSource.data.map(a => a.dataSourceName))];
      } else if (cols[a] == "tagName") {
        unique = [...new Set(this.rulesDataSource.data.map(a => a.tagName))];
      } else if (cols[a] == "cleansingRules") {
        tempFilter.fieldType = FilterFieldTypes.values;
        unique = [...new Set(this.rulesDataSource.data.map(a => a.cleansingRules.length))];
      } else if (cols[a] == "updatedBy") {
        unique = [...new Set(this.rulesDataSource.data.map(a => a.updatedBy))];
      }
      tempFilter.values = unique;
      this.filterList.push(tempFilter);
    }
  }

  /**
   * Returns data from child filter component
   * @param event
   */
  filterResponse(event) {
    if (this.rulesDataSource) {
      let filterResponse: FilterResponseModel = event.filterResponse;
      this.rulesDataSource.data = this.globalService.conditionalDataFiltering(filterResponse, this.rulesDataSource.data);
      this.selectedFilters.push(filterResponse);
      if (this.popover.isOpen()) this.popover.close();
    }
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
      this.rulesDataSource.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.rulesDataSource.data = this.globalService.conditionalDataFiltering(element, this.rulesDataSource.data);
        }
      }
    }
  }

  /**
   * Delete model
   * @param element
   */
  deleteModel(element: RulesModel) {
    let dataToPass = {
      title: 'Delete',
      isDelete: true,
      message: 'Do you really want to delete the rules for tag ' + element.tagName + '?'
    };

    this.selectedCleansingRuleConfigId = element;
    this.globalService.openModelWindow(this.deleteModelAfterConfirmation, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
  }

  /**
   * Delete cleansing rule after confirmation
   * @param thisRef
   */
  deleteModelAfterConfirmation(thisRef: RulesComponent) {
    thisRef.dataCleansingService.deleteCleansingRule(thisRef.selectedCleansingRuleConfigId.cleansingRuleConfigId).subscribe((data: any): void => {
      if (data) {
        thisRef.globalService.showAlert(AlertComponent, { success: true, message: thisRef.selectedCleansingRuleConfigId.tagName + ' deleted successfully' });
        thisRef.getRulesData(thisRef);
      }
    }, (error: Error) => { });
  }

  /**
   * Loads the details only for view
   * @param element
   */
  viewDetails(element: RulesModel) {
    let dataToPass = { ruleData: element, displayType: "view" };
    this.openModelWindow(this.getRulesData, this, CleansingRuleComponent, '80%', 'custom-modalbox', dataToPass);
  }

  /**
   * Loads the details only for editting
   * @param element
   */
  editDetails(element: RulesModel) {
    let dataToPass = { ruleData: element, displayType: "edit" };
    this.openModelWindow(this.getRulesData, this, CleansingRuleComponent, '80%', 'custom-modalbox', dataToPass);
    }

  openModelWindow(methodRef: (thisRef: any, result?: any) => void, thisRef, cleansingComponent, widthOfWindow, panleClassName, dataToPass) {
    const dialogRef = this.dialog.open(cleansingComponent, {
      width: widthOfWindow,
      panelClass: panleClassName,
      data: dataToPass
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        thisRef.isLoader = true;
        thisRef.getRulesData(thisRef);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }
}
